// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/assets/css/theme.css
// module id = 1287
// module chunks = 34